import zhHans from './zh-hans'
import enUS from './en-us'

export default {
	'zh-hans': zhHans,
	'en-us': enUS
}


// WEBPACK FOOTER //
// ./src/comm/i18n/index.js